import React from "react";
import "../../styles/Home.css";
import Hero from "./Hero";
import WhoWeAre from "./WhoWeAre";
import Shipment from "./Shipment";
import VisionMission from "./VisionMission";
import TrustedBrands from "./TrustedBrands";
import Certifications from "./Certifications";
import WhyChooseUs from "./WhyChooseUs";
import Testimonials from "./Testimonials";
import Contact from "./Contact";
import { Helmet } from "react-helmet-async";

function Home() {
  return (
    <>
      <Helmet>
        <title>
          Ponvel Exim – Global Exporters of Food, FMCG & Coir Products | Trusted
          Indian Brand
        </title>
        <meta
          name="description"
          content="Ponvel Exim is a leading global exporter from India, offering high-quality food, FMCG, coir, and textile products. Supplying excellence with reliability worldwide."
        />
        <meta
          name="keywords"
          content="Ponvel Exim, exporters India, global trading company, FMCG exports, food exports, coir products, textile exports, Indian export brand, wholesale exporters"
        />

        {/* Open Graph (Facebook) */}
        <meta
          property="og:title"
          content="Ponvel Exim – Global Exporters of Food, FMCG & Coir Products"
        />
        <meta
          property="og:description"
          content="Explore Ponvel Exim’s diverse export portfolio — from food and FMCG products to coir and home textiles — trusted by global clients."
        />
        <meta
          property="og:image"
          content="https://ponvelexim.com/logo192.png"
        />
        <meta property="og:url" content="https://ponvelexim.com/" />
        <meta property="og:type" content="website" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Ponvel Exim – Global Exporters of Quality Products"
        />
        <meta
          name="twitter:description"
          content="Ponvel Exim delivers premium export solutions in food, FMCG, coir, and textile products to customers worldwide."
        />
        <meta
          name="twitter:image"
          content="https://ponvelexim.com/logo192.png"
        />
      </Helmet>

      <Hero />
      <WhoWeAre />
      <VisionMission />
      <Shipment />
      <TrustedBrands />
      <Certifications />
      <WhyChooseUs />
      <Testimonials />
      <Contact />
    </>
  );
}

export default Home;
